import React, { useState, useEffect } from "react";
import RightSectionEM from "../RightSectionEM/RightSectionEM";
import HeaderComponent from "../../website/HeaderComponent";
import "./allstudents.scss";
import { Link } from "react-router-dom";
import { dummyStudentData, imageLink } from "../../../actions/utility";
import { Collapse, Button, CardBody, Card, Spinner } from "reactstrap";
import { getAllStudents } from "../../../actions/emActions";
import emptyImage from "../../../public/images/empty.svg";
import moment from "moment";

const AllStudents = (props) => {
  const [studentsData, setstudentsData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [userName, setuserName] = useState("");
  const [email, setemail] = useState("");
  const [phoneNumber, setphoneNumber] = useState("");
  const [page, setpage] = useState("1");
  const [limit, setlimit] = useState("20");
  const [loader, setloader] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const getData = () => {
    getAllStudents(2, userName, email, phoneNumber, page, limit).then((res) => {
      setstudentsData(res.data);
      setloader(false);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getData();
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [userName, email, phoneNumber]);

  useEffect(() => {
    setloader(true);
    getData();
  }, [limit]);
  return (
    <div className="AllStudensComponent">
      <HeaderComponent />
      <div style={{ padding: "2vh 0" }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <RightSectionEM />
            </div>

            <div className="col-md-9">
              <div className="filterSection">
                <h5>
                  <i className="fa fa-filter"></i> Filter By:
                </h5>
                <div className="row">
                  <div className="col-md-3">
                    <div>
                      <label className="filterName">Name:</label>
                      <br />
                      <input
                        onChange={(e) => setuserName(e.target.value)}
                        placeholder=""
                        className="searchField"
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div>
                      <label className="filterName">Email:</label>
                      <br />
                      <input
                        onChange={(e) => setemail(e.target.value)}
                        className="searchField"
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div>
                      <label className="filterName">Phone Number:</label>
                      <br />
                      <input
                        onChange={(e) => setphoneNumber(e.target.value)}
                        className="searchField"
                        type="text"
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div>
                      <label className="filterName">Grade:</label>
                      <br />
                      <select className="selectField">
                        <option>Select a Grade</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-12 mt-2">
                    <div className="text-right">
                      <button className="filterBtn" onClick={toggle}>
                        <i className="fa fa-chevron-down"></i> Advanced Filter
                      </button>
                    </div>
                    <Collapse isOpen={isOpen}>
                      {/* <div className="row">
                        <div className="col-md-2">
                          <div>
                            <select className="selectField2">
                              <option>Active/Inactive</option>
                            </select>
                          </div>
                        </div>
                      </div> */}
                      <div className="d-flex flex-nowrap m-auto">
                        <div className="my-auto">
                          <select className="selectField2">
                            <option>Active/Inactive</option>
                            <option>Active</option>
                            <option>Inactive</option>
                          </select>
                        </div>
                        <div className="my-auto ml-3">
                          <input type="checkbox" />
                          <label className="filterName ml-2">Demo Scheduled</label>
                        </div>
                        <div className="my-auto ml-3">
                          <input type="checkbox" />
                          <label className="filterName ml-2">Demo Missed</label>
                        </div>
                        <div className="my-auto ml-3">
                          <input type="checkbox" />
                          <label className="filterName ml-2">Demo Attended</label>
                        </div>
                        <div className="my-auto ml-3">
                          <input type="checkbox" />
                          <label className="filterName ml-2">Converted</label>
                        </div>
                        <div className="my-auto ml-3">
                          <input type="checkbox" />
                          <label className="filterName ml-2">Payment Due</label>
                        </div>
                      </div>
                    </Collapse>
                  </div>
                </div>
              </div>
              <hr />

              <div className="table-responsive">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Name</th>
                      <th scope="col">Contact Info</th>
                      <th scope="col">Joining date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {studentsData &&
                      studentsData.map((item, index) => (
                        <tr>
                          <th scope="row">{index + 1}.</th>
                          <td>
                            <Link to={`/dashboards/StudentDetails/${item.id}`}>
                              <div className="studentimgName">
                                <img
                                  className="studentImgAvatar"
                                  src={item.image !== null ? imageLink(item.image) : emptyImage}
                                />
                                <label className="">{item.user_name}</label>
                              </div>
                            </Link>
                          </td>
                          <td>
                            <div>
                              <label className="mb-0 generalText">
                                <i className="fa fa-envelope mr-2 iconColor"></i>
                                {item.user_email}
                              </label>
                              <br />
                              <label className="mb-0 generalText">
                                <i className="fa fa-phone mr-2 iconColor"></i>{" "}
                                {item?.lm_candidate_profile[0]?.phone}
                              </label>
                            </div>
                          </td>

                          <td>{moment(item.ts).format("Do MMM 'YY")}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="text-center mb-4 mt-2">
                <button
                  className="btn btn-warning btn-sm"
                  onClick={() => {
                    setlimit(+limit + 20);
                  }}
                >
                  {loader ? (
                    <Spinner size="sm" />
                  ) : (
                    <span>
                      Load More <i className="fa fa-chevron-down"></i>
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllStudents;
